import type { AuthenticationToken } from '../interfaces';

export const teacherPortalAuthentication = (authData: AuthenticationToken) => {
  if (authData.status === 'OK') return '';
  return authData.reason || authData.status;
};
